module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec_bg_7-4fce9f03d53ef172c3296e70013bb10a.svg";